import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useServicesQuery } from "@/hooks/use-services";
import { useServiceStore } from "@/stores/service-store";

// Mounted by AppLayout so it runs on every dashboard page, settings included.
export function useSelectedServiceSync() {
  const navigate = useNavigate();
  const { data: services, isSuccess, isFetching } = useServicesQuery();
  const { selectedService, selectedServiceId, setSelectedService } =
    useServiceStore();

  // Waits for isFetching so the refetch after creating a service does not
  // bounce the user to onboarding with the stale empty list.
  useEffect(() => {
    if (isSuccess && !isFetching && (!services || services.length === 0)) {
      navigate("/onboarding", { replace: true });
    }
  }, [isSuccess, isFetching, services, navigate]);

  useEffect(() => {
    if (services && services.length > 0 && !selectedService) {
      // Falls back to the first service when the stored one is gone (deleted,
      // or left over from another account on this browser).
      const serviceToSelect =
        services.find((s) => s.id === selectedServiceId) ?? services[0];
      setSelectedService(serviceToSelect);
    }
  }, [services, selectedService, selectedServiceId, setSelectedService]);
}
